/** 
 * AOS init 
 */
jQuery(document).ready(function ($) {
    if (typeof AOS !== 'undefined') {
        AOS.init({
            startEvent: 'load',
        });
    }
});
